// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__2MAI5","amount":"Amount_amount__2yvba","tip":"Amount_tip__1768x","tipHeader":"Amount_tipHeader__Z59xH","tipsWrap":"Amount_tipsWrap__1EsmF"};